import { cn } from "@/lib/utils";

interface MetricTrendCardProps {
  icon: React.ElementType;
  label: string;
  value: string;
  trendText: string;
  interpretation?: string;
  colorClass: string;
  bgClass: string;
}

export const MetricTrendCard = ({ icon: Icon, label, value, trendText, interpretation, colorClass, bgClass }: MetricTrendCardProps) => {
  return (
    <div className="bg-card rounded-2xl p-4 shadow-sm border flex flex-col h-full">
      <div className="flex items-center gap-2 mb-3">
        <div className={cn("w-8 h-8 rounded-lg flex items-center justify-center shrink-0", bgClass, colorClass)}>
          <Icon className="h-4 w-4" />
        </div>
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</p>
      </div>
      
      <div className="mb-2">
        <span className="text-xl font-heading font-bold text-foreground leading-none block">{value}</span>
      </div>
      
      <div className="mt-auto">
        <span className={cn("text-xs font-semibold block mb-1", colorClass)}>
          {trendText}
        </span>
        {interpretation && (
          <span className="text-[10px] text-muted-foreground block leading-tight">
            {interpretation}
          </span>
        )}
      </div>
    </div>
  );
};
